<template>
  <div id="search">
    <b-container fluid>
      <h2>Under Construction... Please stay tuned :)</h2>
      <!--
      <h2 style="margin-bottom: 25px; margin-top: 20px" v-if="isAuthorized">{{ $t('latestTitle') }} (Total: {{filteredItems.length}})</h2>
      <h2 v-else>You don't have access to the results.</h2>
      <b-row v-if="isAuthorized">
-->
      <!--<b-col xl="3" md="4" >
          <b-row style="margin-left: 5px;" >
            <b-button @click="addFilter"
                      variant="primary"
                      style="margin-bottom: 20px;"
            >
              {{ $t('latestAddFilter') }}
            </b-button>
            <font-awesome-icon style="margin-left: 5px; margin-top: 3px;"
                              :icon="['fas', 'question-circle']"
                              size="2x"
                              v-b-popover.hover="$t('latestFilterDesc')"
            />
          </b-row>
          <div style="margin-left: 20px;" v-for="filter in filters" v-bind:key="filter['id']" >
            <b-form inline style="margin-bottom: 20px;">
              <b-row>
                <b-button pill
                          variant="danger"
                          style="margin-right: 10px; margin-bottom: 10px;"
                          @click="deleteFilter(filter['id']); removeSearchParameters(filter['value'])"
                >
                  {{ $t('latestDelete')}}
                </b-button>
                <b-form-select v-model="filter['value']"
                               style="margin-right: 15px;"
                               :options="options"
                               @change="onFilterChange(filter)"
                />
                <div v-if="filter['value'] == 'id'">
                  <b-form-input v-model="search_parameters['id']"
                                style="margin-top: 15px;"
                                placeholder="Please enter event ID"
                                type="number"/>
                </div>
                <div v-else-if="filter['value'] == 'date'" >
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters['date_min']" style="margin-top: 15px;" type="date"/>
                  </b-row>
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters['date_max']"  type="date"/>
                  </b-row>
                </div>
                <div v-else-if="filter['value'] != 'null' && filter['value']">
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters[filter['value'] + '_min']"
                                  style="margin-top: 15px; "
                                  placeholder="Enter minimum value"
                                  type="number"
                    />
                  </b-row>
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters[filter['value'] + '_max']"
                                  placeholder="Enter maximum value"
                                  type="number"
                    />
                  </b-row>
                </div>
              </b-row>  
            </b-form>
          </div>
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            {{$t('latestOneFilter')}}
          </b-alert>
          <b-row style="margin-left: 5px;">
            <b-button variant="primary"
                      @click="filterItems"
                      v-if="showSubmit"
                      style="margin-bottom: 20px;"
            >
              {{ $t('latestSubmit') }}
            </b-button>
            <b-alert v-model="noResultsFound" variant="light">{{ $t('latestNoResult') }}</b-alert>
          </b-row>
        </b-col>-->
      <!--
        <b-col xl="12" md="8" sm="7">
          <b-row>
            <b-col md="4" class="my-1">
              <b-pagination
                v-if="items.length != 0"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              />
            </b-col>
            <b-col md="4" class="my-1">
              <a class="download-button"
                :href="downloadData"
                :download="'frbs.json'">
                <b-button variant="dark"> 
                  Download FRBs
                </b-button> 
              </a>
            </b-col>
            <b-col md="4" class="my-1">
              <b-form inline>
                <label class="mr-sm-2">Filter:</label>
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                    <b-input-group-append>
                      <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                    </b-input-group-append>
                  </b-input-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" v-if="items.length != 0">
              <b-table  striped bordered outlined small 
                        v-if="items.length != 0"
                        :fields="fields"
                        :items="filteredItems"
                        :current-page="currentPage" 
                        :per-page="perPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
              >
              <template v-slot:cell(source_id)="data">
                <b-link v-bind:href="'/latest/' + data.item.source_id" target="_blank"> {{ data.item.source_id }} </b-link>
              </template>
              <template v-slot:cell(dm)="data">
                {{ data.item.dm }}
                <span v-if="!String(data.item.dm).startsWith('<')">( {{ data.item.dm_error.error_high }} )</span>
              </template>
              </b-table>
            </b-col>
            <b-col md="12" v-else>
              <p>Loading...</p>
              <b-spinner
                v-for="variant in variants"
                :variant="variant"
                :key="variant"
                type="grow"
              ></b-spinner>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
-->
    </b-container>
  </div>
</template>

<script>
import { filterMixin } from "./mixins/filter_mixin.js";
export default {
  name: "search",
  mixins: [filterMixin],
  data() {
    return {
      fields: [
        { key: "source_id", label: "ID", sortable: true },
        { key: "dm", label: "DM", sortable: true },
        { key: "snr", label: "SNR", sortable: true },
        { key: "ra", label: "RA", sortable: true },
        { key: "dec", label: "Dec", sortable: true },
        { key: "date_no_time", label: "Date", sortable: true },
        { key: "time", label: this.$t("latestTime") },
      ],
      options: [
        { value: null, text: this.$t("latestSelect") },
        { value: "id", text: "ID" },
        { value: "dm", text: "DM" },
        { value: "date", text: "Date" },
        { value: "ra", text: "RA" },
        { value: "dec", text: "Dec" },
        { value: "snr", text: "SNR" },
      ],
      whichEvents: "Latest",
    };
  },
  mounted() {
    this.generateItems();
  },
  methods: {
    generateItems() {
      // Generate a master list of all FRBs
      this.noResultsFound = false;
      var url = "https://catalog.chime-frb.ca/frbs";
      // var url = 'http://localhost:8081/frbs'
      return this.$http
        .post(
          url,
          { user_email: localStorage.user_email },
          { responseType: "json", timeout: 10000 }
        )
        .then((response) => {
          this.parseResponse(response.body);
        });
    },
    parseResponse(sources) {
      // Parse data for all bursts and generate an FRB master list
      var sourceNames = Object.keys(sources);
      this.totalRows = sourceNames.length;
      this.downloadItems = sources;
      console.log([sources]);
      for (var i = 0; i < sourceNames.length; i++) {
        var burst = Object.keys(sources[sourceNames[i]])[0];
        var date_string = "2018-07-25 00:00:00.00000";
        var datetime = new Date(date_string);
        var item = {};
        item["source_id"] = sourceNames[i];
        item["burst_id"] = burst;
        item["dm"] = sources[sourceNames[i]][burst]["dm"].value;
        item["dm_error"] = sources[sourceNames[i]][burst]["dm"];
        item["snr"] = sources[sourceNames[i]][burst]["snr"].value;
        item["ra"] = sources[sourceNames[i]][burst]["ra"].value;
        item["dec"] = sources[sourceNames[i]][burst]["dec"].value;
        item["date_no_time"] = date_string.split(" ")[0];
        item["time"] = date_string.split(" ")[1].split(".")[0];
        item["date"] = datetime;
        this.items.push(item);
      }
      console.log(this.items);
      // Create filtered items using no filter, to show all the events by default
      this.filterItems();
      this.whichEvents = "Latest";
    },
    filterItems() {
      // Filters the master list and generates a list of filtered items
      this.whichEvents = "Filtered";
      this.noResultsFound = false;
      this.filteredItems = [];
      // Loop through the master list, check if each item is to be added, parse added items a bit
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (
          this.isToBeAdded(item) ||
          (Object.entries(this.search_parameters).length === 0 &&
            this.search_parameters.constructor === Object)
        ) {
          var filteredItem = {
            dm: item["dm"].toFixed(2),
            snr: item["snr"].toFixed(2),
            ra: item["ra"], //.toFixed(2),
            dec: item["dec"], //.toFixed(2),
            source_id: item["source_id"],
            date_no_time: item["date_no_time"],
            time: item["time"],
            dm_error: item["dm_error"],
          };
          this.filteredItems.push(filteredItem);
        }
      }
      this.totalRows = this.filteredItems.length;
      if (this.filteredItems.length == 0) {
        this.noResultsFound = true;
      }
    },
  },
};
</script>
<style>
.supsub {
  position: absolute;
}
.subscript {
  display: block;
  position: relative;
  left: 2px;
  bottom: -18px;
}
.superscript {
  display: block;
  position: relative;
  left: 2px;
  top: 2px;
}
.download-button {
  display: flex;
  justify-content: center;
  padding: 5px;
  color: #fff;
  opacity: 0.87;
  text-align: center;
}
</style>
